import React from "react"
import ReactTable from "react-table"
import { useQuery } from "@apollo/client"
import { CONTRACT_EXPENSES } from "graphql/vehicle-management/vehicle-management.queries.gql"
import { Spinner } from "@blueprintjs/core"
import { readableDate } from "utils/custom.utils"
import SerialColumn from "components/Organisms/table/SerialColumn"

const ExpenseRecords = ({ contractId }) => {
  const { data, loading } = useQuery(CONTRACT_EXPENSES, {
    variables: { contractId },
  })

  if (loading) return <Spinner />

  const COLUMNS = [
    SerialColumn,
    {
      accessor: "createdAt",
      Header: "Date",
      width: 150,
      Cell({ value }) {
        return readableDate(value)
      },
    },
    {
      Header: "Expense Type",
      accessor: "expenseType",
      Cell({ value }) {
        return value?.name
      },
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Quantity Rate",
      accessor: "quantityRate",
      Cell({ value }) {
        return `₹${value}`
      },
    },
    {
      Header: "Net Amount",
      accessor: "netAmount",
      Cell({ value }) {
        return `₹${value}`
      },
    },
    {
      Header: "Bourne By",
      accessor: "borneBy",
    },
    {
      Header: "Resource Used",
      accessor: "resourceUsed",
    },
  ]
  return (
    <ReactTable
      className="vt-schedule-table-new vt-expense-table"
      data={data?.contractExpenses ?? []}
      columns={COLUMNS}
      showPaginationBottom={false}
    />
  )
}

export default ExpenseRecords
